import React from 'react';
import { observer } from 'mobx-react';
import { Link, useLocation } from "react-router-dom";

import { APP_ROUTES } from '../../utils/constants';
import { replacePathPlaceholders } from '../../utils/helpers';
import StreamViews from './StreamViews';

const LeftNav = observer((props) => {

  const location = useLocation();

  const isActive = function(route){
    const checkRoute = replacePathPlaceholders(route, {bucketSid: props.store.SessionStore.getActiveBucketSid()});
    const currentRoute = location.pathname;
    if(currentRoute === checkRoute){
      return "menu-item active";
    }
    return "menu-item";
  }

  return (
    <>
    {/* Menu */}
    <aside id="layout-menu" className="layout-menu menu-vertical menu bg-menu-theme" style={{overflowY: 'scroll'}}>
      
      <div className="app-brand demo">
        <a href={replacePathPlaceholders(APP_ROUTES.DASHBOARD, {bucketSid: props.store.SessionStore.getActiveBucketSid()})} className="app-brand-link">
          <img src="/assets/images/apitraffic-logo.svg" width="200" alt="ApiTraffic Logo" id="logo"/>
        </a>
          {/* eslint-disable-next-line */}
          <a href="javascript:void(0);" className="layout-menu-toggle menu-link text-large ms-auto">
          <i className="ti ti-x d-block d-xl-none ti-sm align-middle"></i>
        </a>
        {/* eslint-disable-next-line */}
        <a href="javascript:void(0);" className="layout-menu-toggle menu-link text-large ms-auto" id="nav-toggle-handle">
          <i className="ti menu-toggle-icon d-none d-xl-block ti-sm align-middle"></i>
        </a>
      </div>

    <div className="menu-inner-shadow"></div>
    
    
    <ul className="menu-inner py-1">
        
      {/* Apps & Pages */}
      {props.store.SessionStore.bucket?.appIsConnected ? (
        <>
          <li className="menu-header small text-uppercase">
            <span className="menu-header-text">Analyze</span>
          </li>  
            
          <li className={isActive(APP_ROUTES.DASHBOARD)} id="left-nav-dashboard">
            <Link to={replacePathPlaceholders(APP_ROUTES.DASHBOARD, {bucketSid: props.store.SessionStore.getActiveBucketSid()})} className="menu-link">
              <i className="menu-icon tf-icons ti ti-chart-infographic"></i>
              <div data-i18n="Dashboard">Dashboard</div>
            </Link>
          </li>
        </>
      ) : (<>
        <li className="menu-header small text-uppercase mt-4">
            <span className="menu-header-text">General</span>
          </li>  
        <li className={isActive(APP_ROUTES.DASHBOARD)} id="left-nav-sdk-setup">
            <Link to={replacePathPlaceholders(APP_ROUTES.GETTING_STARTED, {bucketSid: props.store.SessionStore.getActiveBucketSid()})} className="menu-link" id="sdk-setup-link">
              <i className="menu-icon tf-icons ti ti-chart-infographic"></i>
              <div data-i18n="Dashboard">Getting Started</div>
            </Link>
          </li>
      </>)}

      
      
      <li className="menu-header small text-uppercase">
        <span className="menu-header-text">Streams</span>
      </li>

      {props.store.SessionStore.bucket?.appIsConnected ? (
        <>
            <li className={isActive(APP_ROUTES.TRAFFIC) || isActive(APP_ROUTES.DASHBOARD)} id="left-nav-all-traffic">
              <Link to={replacePathPlaceholders(APP_ROUTES.TRAFFIC, {bucketSid: props.store.SessionStore.getActiveBucketSid()})} className="menu-link">
                <i className="menu-icon tf-icons ti ti-arrows-right-left"></i>
                <div data-i18n="All Traffic">All Traffic</div>
              </Link>
            </li>
            <li className={isActive(APP_ROUTES.INBOUND_TRAFFIC) || isActive(APP_ROUTES.DASHBOARD)} id="left-nav-all-traffic">
              <Link to={replacePathPlaceholders(APP_ROUTES.INBOUND_TRAFFIC, {bucketSid: props.store.SessionStore.getActiveBucketSid()})} className="menu-link">
                <i className="menu-icon tf-icons ti ti-arrow-right"></i>
                <div data-i18n="Inbound Traffic">Inbound Traffic</div>
              </Link>
            </li>
            <li className={isActive(APP_ROUTES.OUTBOUND_TRAFFIC) || isActive(APP_ROUTES.DASHBOARD)} id="left-nav-all-traffic">
              <Link to={replacePathPlaceholders(APP_ROUTES.OUTBOUND_TRAFFIC, {bucketSid: props.store.SessionStore.getActiveBucketSid()})} className="menu-link">
                <i className="menu-icon tf-icons ti ti-arrow-left"></i>
                <div data-i18n="Outbound Traffic">Outbound Traffic</div>
              </Link>
            </li>
            {/* 
          <li className={isActive(APP_ROUTES.COLLECTIONS)}>
            <Link to={replacePathPlaceholders(APP_ROUTES.COLLECTIONS, {bucketSid: props.store.SessionStore.getActiveBucketSid()})} className="menu-link">
              <i className="menu-icon tf-icons ti ti-package"></i>
              <div data-i18n="Collections">Collections</div>
            </Link>
          </li>
          */}
          <li className={isActive(APP_ROUTES.ERRORS)} id="left-nav-errors">
            <Link to={replacePathPlaceholders(APP_ROUTES.ERRORS, {bucketSid: props.store.SessionStore.getActiveBucketSid()})} className="menu-link">
              <i className="menu-icon tf-icons ti ti-zoom-exclamation"></i>
              <div data-i18n="Errors">Errors</div>
            </Link>
          </li>
          {/* 
          <li className={isActive(APP_ROUTES.SHARED)}>
            <Link to={replacePathPlaceholders(APP_ROUTES.SHARED, {bucketSid: props.store.SessionStore.getActiveBucketSid()})} className="menu-link">
              <i className="menu-icon tf-icons ti ti-share"></i>
              <div data-i18n="Shared">Shared</div>
            </Link>
          </li>
        */}
        </>
      ) : (<></>)}

      
      <li className={isActive(APP_ROUTES.CAPTURES)} id="left-nav-captures">
          <Link to={replacePathPlaceholders(APP_ROUTES.CAPTURES, {bucketSid: props.store.SessionStore.getActiveBucketSid()})} className="menu-link">
              <i className="menu-icon tf-icons ti ti-capture"></i>
              <div data-i18n="Captures">Captures</div>
          </Link>
      </li>
{/* 
      <li className="menu-header small text-uppercase">
        <span className="menu-header-text">Management</span>
      </li>

      <li className={isActive(APP_ROUTES.WORKFLOWS)} id="left-nav-captures">
          <Link to={replacePathPlaceholders(APP_ROUTES.WORKFLOWS, {bucketSid: props.store.SessionStore.getActiveBucketSid()})} className="menu-link">
              <i className="menu-icon tf-icons ti ti-switch-3"></i>
              <div data-i18n="Captures">Workflows</div>
          </Link>
      </li>

      <li className={isActive(APP_ROUTES.WORKFLOWS)} id="left-nav-captures">
          <Link to={replacePathPlaceholders(APP_ROUTES.WORKFLOWS, {bucketSid: props.store.SessionStore.getActiveBucketSid()})} className="menu-link">
              <i className="menu-icon tf-icons ti ti-viewfinder"></i>
              <div data-i18n="Captures">Stream Views</div>
          </Link>
      </li>
*/}
      {props.store.SessionStore.streamViews.length > 0 ? (<StreamViews {...props} />) : (<></>)}

      <li className="menu-header small text-uppercase">
        <span className="menu-header-text">Utilities</span>
      </li>

      {props.store.SessionStore.bucket?.appIsConnected ? (
        <>
          <li className="menu-item" id="left-nav-url-helper">
            <a className="menu-link" id="url-helper-menu-item" href={replacePathPlaceholders(APP_ROUTES.TRAFFIC, {bucketSid: props.store.SessionStore.getActiveBucketSid()})} data-bs-toggle="modal" data-bs-target="#urlHelper">
              <i className="menu-icon tf-icons ti ti-wand"></i>
              <div data-i18n="URL Helper">URL Helper</div>
            </a>
          </li>
          <li className="menu-item" id="left-nav-sdk-setup">
            <Link to={replacePathPlaceholders(APP_ROUTES.GETTING_STARTED, {bucketSid: props.store.SessionStore.getActiveBucketSid()})} className="menu-link" id="sdk-setup-link">
              <i className="menu-icon tf-icons ti ti-code"></i>
              <div data-i18n="URL Helper">SDK Setup</div>
            </Link>
          </li>          
        </>
      ) : (<></>)}

        
        <li className={isActive(APP_ROUTES.SETTINGS)} id="left-nav-bucket-settings">
          <Link to={replacePathPlaceholders(APP_ROUTES.SETTINGS, {bucketSid: props.store.SessionStore.getActiveBucketSid()})} className="menu-link">
            <i className="menu-icon tf-icons ti ti-adjustments"></i>
            <div data-i18n="Bucket Settings">Bucket Settings</div>
          </Link>
        </li>
        <li>&nbsp;</li>


        {/*
        <li className="menu-item">
          <a className="menu-link" id="url-helper-menu-item" href={handleClick} data-bs-toggle="modal" data-bs-target="#tourOptions">
            <i className="menu-icon tf-icons ti ti-wand"></i>
            <div data-i18n="URL Helper">Tours</div>
          </a>
        </li>
        */}
       </ul>
          
        {/*
        <div className="text-center mb-3">
          {(props.store.SessionStore.connectedContextSdks?.length && props.store.SessionStore.connectedContextSdks.length) > 0 ? (
            <button type="button" className="btn btn-label-success text-nowrap d-inline-flex position-relative me-0" onClick={()=>{
              navigate(replacePathPlaceholders(APP_ROUTES.SERVER_CONNECTIONS, {bucketSid: props.store.SessionStore.getActiveBucketSid()})
            )}}>
              API Server{props.store.SessionStore.connectedContextSdks.length || 0 === 1 ? '' : 's'} Connected
              <span className="position-absolute top-0 start-0 translate-middle badge badge-center rounded-pill bg-success text-white">{props.store.SessionStore.connectedContextSdks.length || 0}</span>
            </button>
          ) : (
            <button type="button" className="btn btn-label-danger text-nowrap d-inline-flex position-relative"onClick={()=>{
              navigate(replacePathPlaceholders(APP_ROUTES.GETTING_STARTED, {bucketSid: props.store.SessionStore.getActiveBucketSid()})
            )}}>
              No API Servers Connected
            </button>
          )}
        </div>
      */}
  </aside>
  {/* / Menu */}
  </>
  );
});

export default LeftNav;